<template>
  <b-card no-body class="cardbody-p rounded-md  h-60vh w-full bg-ededed">
    <div class="pm-grey px-4 py-2 rounded-t-md ">
      <p class="text-white font-normal text-sm">RE-OPEN (2)</p>
    </div>
    <div class="px-2 mt-4">
      <div class="pm-overflow-y-primary-color cust-maxht">
        <b-card no-body class="p-2 mb-2">
          <p class=" text-xs text-black font-semibold">
            <span class="text-gray-400 pr-1">DC-165</span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            posuere erat a ante.
          </p>
          <div class="flex justify-end  mt-2">
            <p class=" text-10px font-normal text-mute ">Thursday</p>
          </div>
        </b-card>
        <b-card no-body class="p-2 mb-2">
          <p class=" text-xs text-black font-semibold">
            <span class="text-gray-400 pr-1">DC-165</span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            posuere erat a ante.
          </p>
          <div class="flex justify-end  mt-2">
            <p class=" text-10px font-normal text-mute ">Thursday</p>
          </div>
        </b-card>
      </div>
    </div>
  </b-card>
</template>
<script>
import "@/views/admin/scss/Index.scss";
export default {
  data() {
    return {};
  }
};
</script>
